import {ComponentFactoryResolver,ComponentRef,Directive,Input,OnInit,ViewContainerRef} from "@angular/core";
import { FormGroup } from "@angular/forms";
import { SectionConfig } from "../models/section.interface";
import { SectionComponent } from "../section/section.component";
const componentMapper = {
  section: SectionComponent
};
@Directive({
  selector: '[appSection]'
})
export class SectionDirective {

  @Input() section: SectionConfig;
  @Input() group: FormGroup;
  @Input() index: FormGroup;
  componentRef: any;
  constructor(
    private resolver: ComponentFactoryResolver,
    private container: ViewContainerRef
  ) {}
  ngOnInit() {
    const factory = this.resolver.resolveComponentFactory(
      componentMapper[this.section.type]
    );
    this.componentRef = this.container.createComponent(factory);
    this.componentRef.instance.section = this.section;
    this.componentRef.instance.group = this.group;
    this.componentRef.instance.index = this.index;
  }

}



// WEBPACK FOOTER //
// ./src/app/rFF/directives/section.directive.ts